const isObject = function (data) {
    return typeof data === 'object' && data !== null;
};
export function isResultError(result) {
    if (!isObject(result)) {
        throw new TypeError('[isResultError] result must be an object');
    }
    return 'error' in result && !('response' in result);
}
export function isResultSuccess(result) {
    if (!isObject(result)) {
        throw new TypeError('[isResultSuccess] result must be an object');
    }
    return 'response' in result && !('error' in result);
}
//# sourceMappingURL=result.js.map